import React from "react";
import { CircularProgress, Box, Typography, LinearProgress } from "@mui/material";
import { ID_UPLOAD_LANGUAGE_WAIT_MESSAGE } from "./languagePreference";

const LoadingOverlay = ({ loading, message = "Processing...", progress = null }) => {
  if (!loading) return null;
  const hasProgress = typeof progress === "number";
  const clampedProgress = hasProgress
    ? Math.max(0, Math.min(100, progress))
    : null;

  return (
    <Box
      data-language-switch-blocked="true"
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <CircularProgress
        size={60}
        sx={{ color: "#00756a", mb: 2 }}
        aria-hidden={hasProgress}
      />
      <Typography variant="h6" sx={{ color: "white", textAlign: "center" }}>
        {message}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "white", textAlign: "center", mt: 1, opacity: 0.9, px: 3 }}
      >
        {ID_UPLOAD_LANGUAGE_WAIT_MESSAGE}
      </Typography>
      {hasProgress ? (
        <Box sx={{ width: "min(420px, 80vw)", mt: 3 }}>
          <LinearProgress
            variant="determinate"
            value={clampedProgress}
            sx={{
              height: 10,
              borderRadius: 999,
              backgroundColor: "rgba(255,255,255,0.22)",
              "& .MuiLinearProgress-bar": {
                borderRadius: 999,
                backgroundColor: "#00756a",
              },
            }}
          />
          <Typography
            variant="body2"
            sx={{ color: "white", textAlign: "center", mt: 1, opacity: 0.9 }}
          >
            {Math.round(clampedProgress)}%
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default LoadingOverlay;
